import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Avatar from '@material-ui/core/Avatar';
import AddaPhoto from '@material-ui/icons/AddAPhoto';
import AvatarDialog from '../../../dialogs/Avatar';

import randomstring from 'uuid/v4';

import MultiSelectInput from '../../../inputs/MultiSelectInput';

class CardProduct extends React.Component {
    state = {
        nombre: '',
        tiempovida: undefined,
        idUnidadesmedida: undefined,
        idEstacion: undefined,
        incluirDesperdicio: false,
        edit: false,
        producir: false,
        avisocaducidad: '',
        tiempoproyeccion: '',
        unidadesbasicasproducir: '',
        tramosproyeccion: '',
        foto: undefined,
        familiaproducto: [],
        codigo: '',
        _families: [],
        _units: [],
        _workStations: [],
        avatarDialog: false,
    };

    handleChange = (event) => {
        this.props.onChange(event.target.name, event.target.value);
        this.setState({ [event.target.name]: event.target.value, edit: true });
    };

    handleChangefamiliaproducto = (event) => {
        this.props.onChange('familiaproducto', event.map((f) => f.value));
        this.setState({ familiaproducto: event });
    };

    handleChecked = (event) => {
        this.props.onChange(event.target.name, event.target.checked);
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    openAvatarDialog = (event) => {
        this.setState({ avatarDialog: true });
    };

    closeAvatarDialog = (foto) => {
        if (foto) {
            this.props.onChange('foto', foto);
            this.setState({ avatarDialog: false, foto: foto });
        } else {
            this.setState({ avatarDialog: false });
        }
    };

    static getDerivedStateFromProps(props, state) {
        if (props.data && props.data.id !== state.id) {
            const {
                id,
                nombre,
                foto,
                producir,
                preparar,
                tiempovida,
                idUnidadesmedida,
                idEstacion,
                unidadesbasicasproduccion,
                avisocaducidad,
                tiempoproyeccion,
                tramosproyeccion,
                familiaproducto,
                codigoExterno,
                incluirDesperdicio,
                _families,
                _units,
                _workStations,
            } = props.data;

            state.id = id;
            state.nombre = nombre ? nombre : '';
            state.foto = foto ? foto : '';
            state.producir = producir ? producir : true;
            state.preparar = preparar ? preparar : true;
            state.tiempovida = tiempovida ? tiempovida : '';
            state.idUnidadesmedida = idUnidadesmedida ? idUnidadesmedida : undefined;
            state.idEstacion = idEstacion ? idEstacion : undefined;
            state.unidadesbasicasproduccion = unidadesbasicasproduccion
                ? unidadesbasicasproduccion
                : '';
            state.incluirDesperdicio = incluirDesperdicio ? incluirDesperdicio : false;
            state.avisocaducidad = avisocaducidad ? avisocaducidad : '';
            state.tiempoproyeccion = tiempoproyeccion ? tiempoproyeccion : '';
            state.tramosproyeccion = tramosproyeccion ? tramosproyeccion : '';
            state.familiaproducto =
                familiaproducto && _families
                    ? familiaproducto.reduce((arr, value) => {
                          const familia = _families.find((f) => f.id === value);
                          if (familia) {
                              arr.push({
                                  label: familia.nombre,
                                  value: familia.id,
                              });
                          }
                          return arr;
                      }, [])
                    : [];
            state.codigoExterno = codigoExterno ? codigoExterno : '';
            state._families = _families ? _families : [];
            state._units = _units ? _units : [];
            state._workStations = _workStations ? _workStations : [];
            return state;
        }
        return null;
    }

    render() {
        const { intl } = this.props;
        const {
            nombre,
            foto,
            tiempovida,
            idEstacion,
            idUnidadesmedida,
            incluirDesperdicio,
            unidadesbasicasproduccion,
            producir,
            avisocaducidad,
            tiempoproyeccion,
            tramosproyeccion,
            familiaproducto,
            codigoExterno,
            _families,
            _units,
            _workStations,
            avatarDialog,
        } = this.state;
        return (
            <Card className={'product_card'}>
                <div className="width100 bg_ice_blue shadow" style={{ height: '85px' }} />
                <div className="flex_full_row center">
                    <Avatar className={'avatar-user-menu bg_bluish'}>
                        {foto && <img src={foto} alt="Preview" onClick={this.openAvatarDialog} />}
                        {!foto && (
                            <AddaPhoto
                                className={'c_white'}
                                style={{ fontSize: 48 }}
                                onClick={this.openAvatarDialog}
                            />
                        )}
                    </Avatar>
                </div>
                {avatarDialog && <AvatarDialog open={true} handleClose={this.closeAvatarDialog} />}
                <CardContent>
                    <Grid container justify="center" className={'flex_grow_1'}>
                        <Grid item xs={3} className="padding_top_48">
                            <div className="barlow_regular_small c_slate_grey upper margin_right_18 margin_top_12 text_align_right ">
                                {intl.formatMessage({ id: 'recipe_basic' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="padding_top_24 padding_bottom_48">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_12">
                                    <TextField
                                        fullWidth
                                        id={'nombre'}
                                        name={'nombre'}
                                        required
                                        label={intl.formatMessage({ id: 'recipe_name' })}
                                        className={'flex_full_row'}
                                        value={nombre}
                                        onChange={this.handleChange}
                                        margin="normal"
                                    />
                                    <div className="flex_full_row margin_left_12">
                                        <TextField
                                            fullWidth
                                            id={'codigoExterno'}
                                            name={'codigoExterno'}
                                            label={intl.formatMessage({ id: 'recipe_code' })}
                                            className={'flex_full_row'}
                                            value={codigoExterno}
                                            onChange={this.handleChange}
                                            margin="normal"
                                        />
                                    </div>
                                </div>
                                <div className="flex_full_row margin_bottom_12">
                                    <div className="flex_full_row padding_top_16">
                                        <FormControl
                                            className={'flex_full width100 barlow_italic c_slate'}
                                        >
                                            <InputLabel htmlFor="idLocal" shrink>
                                                {intl.formatMessage({ id: 'recipe_unit' })}
                                            </InputLabel>
                                            <Select
                                                native
                                                name={'idUnidadesmedida'}
                                                id={'idUnidadesmedida'}
                                                value={idUnidadesmedida}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'idUnidadesmedida',
                                                    id: 'idUnidadesmedida',
                                                }}
                                            >
                                                <option key={randomstring()} value={undefined} />
                                                {_units &&
                                                    _units.map((u) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                value={u.id}
                                                            >
                                                                {u.nombre}
                                                            </option>
                                                        );
                                                    })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="flex_full_row margin_bottom_12">
                                    <div className="flex_full_row padding_top_16">
                                        <FormControl
                                            className={'flex_full width100 barlow_italic c_slate'}
                                        >
                                            <InputLabel htmlFor="idLocal" shrink>
                                                {intl.formatMessage({ id: 'recipe_workstation' })}
                                            </InputLabel>
                                            <Select
                                                native
                                                name={'idEstacion'}
                                                id={'idEstacion'}
                                                value={idEstacion}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'idEstacion',
                                                    id: 'idEstacion',
                                                }}
                                            >
                                                <option key={randomstring()} value={undefined} />
                                                {_workStations &&
                                                    _workStations.map((w) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                value={w.id}
                                                            >
                                                                {w.nombre}
                                                            </option>
                                                        );
                                                    })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="flex_full_row margin_bottom_12 text_align_left">
                                    <MultiSelectInput
                                        defaultValue={familiaproducto}
                                        placeHolder={intl.formatMessage({
                                            id: 'recipe_families',
                                        })}
                                        options={
                                            _families
                                                ? _families.map((f) => {
                                                      return { label: f.nombre, value: f.id };
                                                  })
                                                : []
                                        }
                                        onChange={this.handleChangefamiliaproducto}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small margin_right_18 margin_top_12 text_align_right c_slate_grey upper">
                                {intl.formatMessage({ id: 'recipe_detail_production' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_12 align_center">
                                    <div className="flex_full_row barlow_medium_subtitle c_dark_grey_blue">
                                        {intl.formatMessage({ id: 'recipe_waste_label' })}
                                    </div>
                                    <Switch
                                        name={'incluirDesperdicio'}
                                        checked={incluirDesperdicio}
                                        onChange={this.handleChecked}
                                        value="incluirDesperdicio"
                                        color="primary"
                                    />
                                </div>
                                <div className="flex_full_row margin_bottom_12 align_center">
                                    <div className="flex_full_row barlow_medium_subtitle c_dark_grey_blue">
                                        {intl.formatMessage({ id: 'recipe_on_production' })}
                                    </div>
                                    <Switch
                                        name={'producir'}
                                        checked={producir}
                                        onChange={this.handleChecked}
                                        value="producir"
                                        color="primary"
                                    />
                                </div>
                                {producir && (
                                    <React.Fragment>
                                        <div className="flex_full_row margin_bottom_12 align_baseline">
                                            <div className="barlow_medium_subtitle c_dark_grey_blue">
                                                {intl.formatMessage({
                                                    id: 'recipe_count_basic_units',
                                                })}
                                            </div>
                                            <TextField
                                                id={'unidadesbasicasproduccion'}
                                                name={'unidadesbasicasproduccion'}
                                                required={producir}
                                                className={'margin_left_12'}
                                                value={unidadesbasicasproduccion}
                                                onChange={this.handleChange}
                                                margin="normal"
                                                type="number"
                                            />
                                        </div>
                                        <div className="flex_full_row margin_bottom_12 align_center">
                                            <TextField
                                                fullWidth
                                                id={'tiempovida'}
                                                name={'tiempovida'}
                                                required={producir}
                                                label={intl.formatMessage({ id: 'recipe_life' })}
                                                className={'flex_full_row'}
                                                value={tiempovida}
                                                onChange={this.handleChange}
                                                margin="normal"
                                                type="number"
                                                InputProps={{
                                                    pattern: '[0-9]*',
                                                    style: { textAlign: 'center' },
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            min
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <div className="flex_full_row margin_left_12">
                                                <TextField
                                                    fullWidth
                                                    id={'avisocaducidad'}
                                                    name={'avisocaducidad'}
                                                    required={producir}
                                                    label={intl.formatMessage({
                                                        id: 'recipe_expiration_warning',
                                                    })}
                                                    className={'flex_full_row'}
                                                    value={avisocaducidad}
                                                    onChange={this.handleChange}
                                                    margin="normal"
                                                    type="number"
                                                    InputProps={{
                                                        pattern: '[0-9]*',
                                                        style: { textAlign: 'center' },
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                min
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex_full_row margin_bottom_12">
                                            <TextField
                                                id={'tiempoproyeccion'}
                                                name={'tiempoproyeccion'}
                                                required={producir}
                                                label={intl.formatMessage({
                                                    id: 'recipe_projection_time',
                                                })}
                                                className={'text_align_right padding_right_12'}
                                                value={tiempoproyeccion}
                                                type="number"
                                                onChange={this.handleChange}
                                                margin="normal"
                                                InputProps={{
                                                    pattern: '[0-9]*',
                                                    style: { textAlign: 'center' },
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            min
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div className="flex_full_row margin_bottom_12 align_center">
                                            <div className="flex_full_row barlow_medium_subtitle c_dark_grey_blue padding_right_12 text_align_left">
                                                {intl.formatMessage({ id: 'recipe_stretch' })}
                                            </div>
                                            <TextField
                                                id={'tramosproyeccion'}
                                                name={'tramosproyeccion'}
                                                required={producir}
                                                className={'text_align_right padding_right_12'}
                                                value={tramosproyeccion}
                                                type="number"
                                                onChange={this.handleChange}
                                                margin="normal"
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

CardProduct.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(CardProduct);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/recipe/Card.js